<template>
  <header
    class="navbar navbar-dark sticky-top flex-md-nowrap p-0 shadow"
    :style="bg_color_setting"
  >
    <div class="container-fluid">
      <span
        class="navbar-brand col-md-2 me-0 px-3"
        href="#"
        style="
          background-color: transparent !important;
          box-shadow: none !important;
        "
      >
        <a class="d-inline-block mx-1 px-2" @click="$emit('toggle')">
          <i class="bi bi-list"></i
        ></a>
        <span class="d-inline-block mx-1">MFJ</span>
      </span>
      <span class="col-md-8 text-white px-2">
        {{ auth_label }}
        <!-- ::{{ auth_level }}::{{ auth_rel }} -->
      </span>
      <div class="col-md-2 px-2 py-1">
        <div class="input-group" v-if="false">
          <bs-select
            :options="year_list"
            v-model="target_year"
            :null-option="false"
            id="TargeYear"
            :classParam="'form-select'"
          ></bs-select>
          <button
            @click="update_year"
            type="button"
            class="btn btn-sm btn-light btn-outline-secondary"
          >
            設定
          </button>
        </div>
        <div class="input-group">
          <button
            v-if="manage_account_level_disp"
            @click="reload_login"
            type="button"
            class="btn btn-sm btn-light btn-outline-secondary"
          >
            リロード
          </button>
          <button
            @click="go_manual"
            class="btn btn-sm btn-light btn-outline-secondary"
            type="button"
          >
            マニュアル
          </button>
        </div>
      </div>
    </div>
  </header>
</template>
<style scoped>
.padding_zero {
  border: solid 1px #999;
  padding: 2px !important;
}
.navbar .form-control {
  /* padding: initial !important;
        border-width: initial !important;
        border-radius: initial !important; */
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
  padding-left: 0.25rem !important;
  border-radius: 0.25rem !important;
  border: 1px solid #ced4da !important;
}
</style>
<script>
// import Vue from 'vue'

import BsSelect from '../atoms/BsSelect.vue'
import Common from '../../common/common'
//   import { mapState } from 'vuex'
export default {
  name: 'BsHeaderView',
  data: function () {
    return {
      auth: this.$store.state.auth,
      login: false,
      target_year: ''
      // member: {}
      //   count: this.$store.state.count
    }
  },
  props: {
    front_view: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    bg_color_setting() {
      if (this.get_base_env !== 'production') {
        return 'z-index:9999; background-color:#000;'
      }
      return 'z-index: 9999;background: linear-gradient(#6f83b3, #133e99, #95bbee);'
    },
    year_list: function () {
      let min = 1995
      const max = Common.getNowYear()
      const tmps = []
      for (let i = min; i <= max + 1; i++) {
        tmps.push({
          key: i,
          label: i + '年度'
        })
      }
      return tmps
    },
    auth_label() {
      if (!this.$store.state.auth) {
        return '-'
      } else if (this.$store.state.auth.label) {
        return this.$store.state.auth.label
      } else {
        return '-'
      }
    },
    auth_level() {
      if (!this.$store.state.auth) {
        return '-'
      } else if (this.$store.state.auth.level) {
        return this.$store.state.auth.level
      } else {
        return '-'
      }
    },
    auth_rel() {
      if (!this.$store.state.auth) {
        return '-'
      } else if (this.$store.state.auth.relations) {
        return this.$store.state.auth.relations
      } else {
        return '-'
      }
    },
    get_target_year() {
      if (!this.$store.state.auth) {
        return ''
      } else if (this.$store.state.auth.year) {
        return this.$store.state.auth.year
      } else {
        return ''
      }
    },
    //   ...mapState(['count']),
    authLogin() {
      // validを使ってログイン処理の可否、progressは後述
      if (!this.$store.state.auth || !this.$store.state.auth.token) {
        return false
      } else {
        return true
      }
    },
    header_class() {
      if (this.front_view) {
        return 'not-header'
      }
      return 'header'
    }
  },
  components: {
    BsSelect
  },
  async created() {
    this.target_year = this.get_target_year
  },
  methods: {
    go_manual() {
      this.$router.push({ path: '/manage/manual' })
    },
    reload_login() {
      if (!this.auth || !this.auth?.token) {
        alert('error')
        return false
      }
      const authInfo = {}
      authInfo['token'] = this.auth?.token
      console.log('reload_login', authInfo)
      return this.$store
        .dispatch('tokenLogin', authInfo)
        .then(() => {
          console.log('login success', authInfo)
          // this.$router.push({ path: '/' })
        })
        .catch(err => {
          console.log('handleLogin err', err)
          this.throwReject(err)
        })
        .finally(() => {
          // this.$router.push({ path: '/' })
        })
    },
    update_year() {},
    toggleMenu() {
      this.$refs.navButton.classList.toggle('navButton--open')
      this.$refs.navBody.classList.toggle('nav--open')
    }
  }
}
</script>
